import {
  CourseEnrollmentStatus,
  GetViewerLearningDetailsQuery,
} from '@sandtech-hub-monorepo/ehub-client';
import { Progress } from '@sandtech-hub-monorepo/ui-kit';

type PlannedCourses = NonNullable<
  NonNullable<GetViewerLearningDetailsQuery['viewer']['programEnrollments']>
>[number]['plannedCourses'];

type Props = {
  plannedCourses: PlannedCourses;
};

export const ProgramProgressBar = ({ plannedCourses }: Props) => {
  const totalCourses = plannedCourses.length;
  const graduatedCourses = plannedCourses.filter(
    (c) => c.enrollment?.status === CourseEnrollmentStatus.Graduated
  );

  const percent =
    totalCourses > 0
      ? Math.round((graduatedCourses.length / totalCourses) * 100)
      : 0;

  return (
    <div className="flex flex-col gap-2 mt-2 max-w-md w-full">
      <div className="flex items-center justify-between text-sm">
        <span className="text-muted-foreground">
          {graduatedCourses.length} of {totalCourses} courses completed
        </span>
        <span className="font-semibold text-foreground">{percent}%</span>
      </div>
      <Progress value={percent} className="h-2" />
    </div>
  );
};
